import FilterBar from "Components/Common/FilterBar/FilterBar";
import AreaFilterCard from "Components/Common/FilterBar/FilterCards/AreaFilterCard/AreaFilterCard";
import RoleFilterCard from "Components/Common/FilterBar/FilterCards/RoleFilterCard/RoleFilterCard";
import YesNoFilterCard from "Components/Common/FilterBar/FilterCards/YesNoFilterCard/YesNoFilterCard";
import i18n from "i18next";
import { Area } from "Models/Areas/Area";
import { RoleType } from "Models/Users/RoleType";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IChecklistTemplateAction } from "Store/ChecklistTemplates/ChecklistTemplateAction";
import { ChecklistTemplateFilterState } from "Store/ChecklistTemplates/ChecklistTemplateFilterState";
import { IChecklistTemplateState } from "Store/ChecklistTemplates/ChecklistTemplateState";
import { IApplicationState } from "Store/Store";

const checklistTemplateAction = ServiceProvider.get<IChecklistTemplateAction>(Types.IChecklistTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getChecklistTemplatesByFilterAsync: (filterState: ChecklistTemplateFilterState) =>
        dispatch(checklistTemplateAction.getChecklistTemplatesByFilterAsync(filterState, true)),
});

const mapStateToProps = (state: IApplicationState) => ({
    checklistTemplateState: state.checklistTemplateState
});

interface IProps {
    checklistTemplateState: IChecklistTemplateState;
    getChecklistTemplatesByFilterAsync: (filterState: ChecklistTemplateFilterState) => Action;
}

interface IState {
    selectedArea?: Area;
    selectedRoles: RoleType[];
    instructionsAttached?: boolean;
    photoAttached?: boolean;
}

export class ChecklistTemplateFilters extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    public static readonly DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        if (this.props.checklistTemplateState.currentFilter) {
            this.state = {
                selectedArea: this.props.checklistTemplateState.currentFilter.area,
                selectedRoles: this.props.checklistTemplateState.currentFilter.roles || [],
                instructionsAttached: this.props.checklistTemplateState.currentFilter.instructionsAttached,
                photoAttached: this.props.checklistTemplateState.currentFilter.photoAttached
            };
        }
        else {
            this.state = {
                selectedRoles: []
            };
        }

        this.onChangeRoles = this.onChangeRoles.bind(this);
        this.onChangeInstructionAttached = this.onChangeInstructionAttached.bind(this);
        this.onChangePhotoAttached = this.onChangePhotoAttached.bind(this);
        this.onChangeArea = this.onChangeArea.bind(this);
        this.clear = this.clear.bind(this);
    }

    public onChangeRoles(selectedRoles: RoleType[]) {
        this.setState({
            selectedRoles
        });

        this.filter();
    }

    public onChangeInstructionAttached(value?: boolean) {
        this.setState({
            instructionsAttached: value
        });

        this.filter();
    }

    public onChangePhotoAttached(value?: boolean) {
        this.setState({
            photoAttached: value
        });

        this.filter();
    }

    public onChangeArea(area?: Area) {
        this.setState({
            selectedArea: area
        });

        this.filter();
    }

    public filter() {
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }

        const debounceFunction = () => {
            const filter: ChecklistTemplateFilterState = {
                ...this.props.checklistTemplateState.currentFilter,
                area: this.state.selectedArea,
                roles: this.state.selectedRoles,
                instructionsAttached: this.state.instructionsAttached,
                photoAttached: this.state.photoAttached,
                skip: 0
            };
            this.props.getChecklistTemplatesByFilterAsync(filter);
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), ChecklistTemplateFilters.DEBOUNCE_TIMEOUT);
    }

    public clear() {
        this.setState({
            selectedArea: undefined,
            selectedRoles: [],
            instructionsAttached: undefined,
            photoAttached: undefined
        });
        this.filter();
    }

    public render() {
        return (
            <FilterBar onClear={this.clear}>
                <AreaFilterCard onSelectArea={this.onChangeArea} selectedArea={this.state.selectedArea} />
                <RoleFilterCard selectedRoles={this.state.selectedRoles} onChange={this.onChangeRoles} />
                <YesNoFilterCard title={i18n.t("tasks.filters.instructionsAttached")} value={this.state.instructionsAttached} onChange={this.onChangeInstructionAttached} />
                <YesNoFilterCard title={i18n.t("tasks.filters.photoAttached")} value={this.state.photoAttached} onChange={this.onChangePhotoAttached} />
            </FilterBar>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistTemplateFilters);


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateFilters/ChecklistTemplateFilters.tsx